import * as mainTerms from '../../mainTerms';
import { advertiser } from './advertiser';

const campaignDef = mainTerms.Setting.campaign.default;

const partnerDef = mainTerms.Setting.partner.default;
const advertiserDef = mainTerms.Setting.advertiser.default;

const impDef = mainTerms.Other.impression;
const clickDef = mainTerms.Other.click;

export const campaign = {
    title: campaignDef,
    purpose: {
        label: '목표',
        participative: '참여',
        install: '앱 설치',
        description: '광고 목적에 따라 ' + campaignDef + ' 목표를 선택하세요.',
        error: {
            required: campaignDef + ' 목표를 선택해주세요',
        },
    },
    status: {
        label: '노출 상태',
        active: '활성',
        inactive: '비활성',
    },
    name: {
        label: campaignDef + ' 이름',
        placeholder: '이름을 입력해주세요.',
        error: {
            required: campaignDef + ' 이름을 입력해주세요',
        },
    },
    customID: {
        label: '커스텀 ID',
        placeholder: '커스텀 ID를 입력해주세요',
        description: campaignDef + '과 함께 사용할 커스텀 ID를 설정할 수 있습니다.\n본 설정의 사용을 위해 사업팀을 통해 문의해주시기 바랍니다.'
    },
    budget: {
        label: '예산',
        inactive: '무제한',
        active: '직접 입력',
        placeholder: {
            type: '예산 방식을 설정해주세요.',
        },
        error: {
            notZero: '예산을 0으로 설정하실 수 없습니다.',
        },
        description: campaignDef + ' 기간 동안 이 ' + campaignDef + '에서 지출할 최대 예산을 설정하세요.',
    },
    date: {
        label: campaignDef + ' 일정',
        placeholder: {
            begin: '시작일',
            end: '종료일',
        },
        description: campaignDef + '을 진행할 시작일과 종료일을 설정하세요.',
        error: {
            required: campaignDef + '을 진행할 시작일과 종료일을 설정해주세요.'
        }
    },
    app: {
        label: '앱',
        placeholder: '앱 선택',
        description: '이 ' + campaignDef + '과 연결해 광고를 게재할 앱을 선택하세요.',
        error: {
            required: '앱을 선택해주세요',
        },
    },
    // partner: {
    //     label: partnerDef,
    //     advertiser: advertiserDef,
    //     placeholder: {
    //         company: partnerDef + ' 선택',
    //         advertiser: advertiserDef + ' 선택',
    //     },
    //     description: '이 ' + campaignDef + '을 함께하는 ' + partnerDef + '와 ' + advertiserDef + '를 설정하세요.', 
    //     error: {
    //         company: {
    //             required: partnerDef + '를 선택해주세요',
    //         },
    //         advertiser: {
    //             required: advertiserDef + '를 선택해주세요',
    //         },
    //     },
    // },
    partner: {
        label: advertiserDef,
        advertiser: advertiserDef,
        placeholder: {
            company: partnerDef + ' 선택',
            advertiser: advertiserDef + ' 선택',
        },
        description: '이 ' + campaignDef + '을 함께하는 ' + advertiserDef + '를 설정하세요.', 
        error: {
            company: {
                required: partnerDef + '를 선택해주세요',
            },
            advertiser: {
                required: advertiserDef + '를 선택해주세요',
            },
        },
    },
    category: {
        label: campaignDef + ' 카테고리 설정',
        placeholder: {
            major: '카테고리 선택',
            sub: '세부 카테고리 선택',
        },
        description: campaignDef + ' 성격에 맞는 카테고리를 설정하세요.',
    },
    country: {
        label: '광고 대상 국가',
        placeholder: '광고 대상 국가 선택',
        description: '이 ' + campaignDef + '이 광고를 노출시킬 대상 국가를 설정하세요.',
    },
    tracking: {
        label: '트래킹 툴',
        placeholder: '트래킹 툴 선택',
        description: '포스트백 설정 시 사용할 트래킹 툴을 설정하세요.',
    },
    totalFrequency: {
        label: '총 광고 빈도',
        inactive: '비활성화',
        active: '활성화',
        impression: impDef,
        click: clickDef,
        description: '사용자 별 최대 노출 횟수와 클릭 횟수를 설정할 수 있습니다.',
    },
    dailyFrequency: {
        label: '일일 광고 빈도',
        inactive: '비활성화',
        active: '활성화',
        impression: impDef,
        click: clickDef,
        description: '각 사용자의 일별 최대 ' + impDef + ' 횟수와 ' + clickDef + ' 횟수를 설정할 수 있습니다.',
    },
    impressionInterval: {
        label: impDef + ' 주기',
        inactive: '비활성화',
        active: '활성화',
        description: '사용자에게 일정 주기마다 광고를 노출하도록 설정할 수 있습니다.',
        error: {
            notZero: impDef + ' 주기를 0분으로 설정하실 수 없습니다.',
        },
    },
    dailyEquality: {
        label: '일간 균등 노출',
        inactive: '비활성화',
        active: '활성화',
        description: campaignDef + '  예산을 균등하게 소진되도록 광고를 노출합니다.\n**예산을 무제한으로 설정할 경우, 본 기능을 이용하실 수 없습니다.**',
        error: {
            inventoryBudgetRequired: '예산이 무제한일 경우, 본 기능을 이용하실 수 없습니다.'
        }
    },
    impWeight: {
        label: '노출 가중치',
        placeholder: '노출 가중치 선택',
        description: '광고 노출 시 본 캠페인을 우선 노출하기 위해 가중치를 설정하실 수 있습니다.'
    }
}
